import { BrowserRouterApp } from '@esg/ui';
import { PropsWithChildren } from 'react';

export const ManagementBrowserRouter: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <BrowserRouterApp>
            {children}
        </BrowserRouterApp>
    );
};